<div class="controlPanel-container">
    <p class="title">{{conControlPanelEntity.name}}</p>
    <iframe height="100%" width="100%"  [src]="conControlPanelEntity.link | safe"  frameborder="0" allowFullScreen="true"></iframe>
</div>